<template>
  <v-row justify="center">
    <v-dialog
      v-model="dialog"
      persistent
      max-width="550"
      content-class="rounded-lg"
      scrollable
      @keydown.esc="dialog = false"
    >
      <v-card>
        <v-card-title class="text-body-1 text-sm-h6">
          <span class="black--text text-uppercase font-weight-bold">{{
            isVerification ? "Verifikasi Pembayaran" : "Lihat Verifikasi Pembayaran"
          }}</span>
          <v-spacer></v-spacer>
          <v-btn text small color="pink" class="mr-n4" @click="modalHide">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-0">
          <v-row align="center" justify="center">
            <v-col cols="12" class="pt-0">
              <div class="text-body-2 font-weight-bold pb-1">Bank Pembayaran</div>
              <v-autocomplete
                outlined
                :disabled="!isVerification"
                :items="bankAccountList"
                class="rounded-lg text-body-2 width-0"
                color="primary"
                dense
                hide-details="auto"
                return-object
                v-model="selectedBank"
                @focus="() => (responseError.bank_account_id = '')"
                :error-messages="responseError.bank_account_id"
              >
                <template v-slot:selection="{ item }">
                  <v-col class="pa-0">
                    <div class="d-md-flex justify-space-between">
                      <img
                        width="15%"
                        :src="`/assets/bank/${item.bank_account_bank_name.toLowerCase()}.svg`"
                      />
                      <div class="my-auto text-body-2">
                        {{ item.bank_account_number }}
                        {{ item.bank_account_name }}
                      </div>
                    </div>
                  </v-col>
                </template>
                <template v-slot:item="{ item }">
                  <v-col class="pa-0">
                    <div class="d-md-flex">
                      <img
                        width="15%"
                        :src="`/assets/bank/${item.bank_account_bank_name.toLowerCase()}.svg`"
                      />
                      <div class="my-auto text-body-2 pl-2">
                        {{ item.bank_account_number }}
                        {{ item.bank_account_name }}
                      </div>
                    </div>
                  </v-col>
                </template>
              </v-autocomplete>
            </v-col>
            <template>
              <v-col cols="12" class="pt-0">
                <div class="text-body-2 font-weight-bold pb-1">Total Tagihan</div>
                <v-currency-field
                  :disabled="true"
                  v-model="form_data.total_invoice"
                  outlined
                  class="rounded-lg text-body-2"
                  dense
                  hide-details="auto"
                  prefix="Rp"
                  @focus="() => (responseError.transfer_value = '')"
                  :error-messages="responseError.transfer_value"
                ></v-currency-field>
              </v-col>
              <v-col cols="12" class="pt-0">
                <div class="text-body-2 font-weight-bold pb-1">Jumlah Transfer</div>
                <v-currency-field
                  @input="calculateAmount"
                  @change="calculateAmount"
                  :disabled="!isVerification"
                  v-model="form_data.finance_amount"
                  outlined
                  :max="form_data.total_invoice"
                  class="rounded-lg text-body-2"
                  dense
                  hide-details="auto"
                  prefix="Rp"
                  @focus="() => (responseError.transfer_value = '')"
                  :error-messages="responseError.transfer_value"
                ></v-currency-field>
              </v-col>
            </template>
            <v-col cols="12" class="pt-2 pb-1">
              <div class="text-body-2 font-weight-bold pb-1">Bukti Bayar Pembeli</div>
              <v-row class="justify-center">
                <v-col cols="10" sm="6" class="pa-0">
                  <v-img
                    width="100%"
                    :src="
                      form_data.cs_attachment_url
                        ? form_data.cs_attachment_url
                        : '/assets/seller/default-toko.svg'
                    "
                  ></v-img>
                </v-col>
                <!-- <span class="pa-2 text-center">Format gambar .jpg .jpeg .png dan ukuran minimum 300 x 300 px (Untuk gambar optimal gunakan minimum 700 x 700 px)</span> -->
              </v-row>
            </v-col>
            <!-- <v-col cols="12" class="pt-2">
							<v-file-input @change="handleFileUpload" v-show="false" accept="image/*" id="inputImage" truncate-length="50"></v-file-input>
							<v-btn outlined block color="primary" large class="text-capitalize font-weight-bold text-body-2 rounded-lg" @click="openUpload">
								<v-icon>mdi-plus</v-icon>
								<span class="pl-2">Upload Bukti Pembayaran</span>
							</v-btn>
						</v-col> -->
            <v-col cols="12" class="pt-2">
              <div class="text-body-2 font-weight-bold pb-1">Catatan</div>
              <v-textarea
                v-model="form_data.note"
                outlined
                :disabled="form_data.previous_status !== 'pending'"
                class="rounded-lg text-body-2"
                hide-details="auto"
                height="110"
                no-resize
              ></v-textarea>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-col v-if="isVerification" cols="12" class="text-center">
            <v-btn
              depressed
              color="dark"
              large
              :loading="loadingPayment"
              class="text-capitalize font-weight-bold text-body-2 rounded-lg"
              @click="confirm('approved')"
              >Konfirmasi</v-btn
            >
            <v-btn
              outlined
              color="red"
              large
              :loading="loadingPayment"
              class="ml-3 text-capitalize font-weight-bold text-body-2 rounded-lg"
              @click="confirm('rejected')"
              >Tolak</v-btn
            >
          </v-col>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      dialog: false,
      bank: [
        {
          name: "Bank BCA",
          norek: "456 789 1410",
          img: "/assets/bank/bca.svg",
        },
      ],
      selectedBank: {},
      min_transfer: 0,
      formData: new FormData(),
      image: "",
      bank_from: "",
      sender_name: "",
      is_top: "0",
      sender_number: "",
      sending_value: "",
      form_data: {},
      isVerification: false,
      note: "",
      previous_status: "pending",
    };
  },
  props: {
    loadingPayment: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("options", ["listBank", "bankAccountList"]),
    ...mapState("transaction", ["responseError"]),
  },
  methods: {
    calculateAmount(val) {
      if (val > this.form_data.total_invoice) {
        this.form_data.finance_amount = this.form_data.total_invoice;
      }
    },
    hideDialog() {
      this.$emit("hideDialog");
    },
    modalShow(bank, data, isVerification) {
      this.dialog = true;
      this.selectedBank = bank;
      this.form_data = data;
      this.isVerification = isVerification;
      this.previous_status = form_data.previous_status;
    },
    modalHide() {
      this.dialog = false;
    },
    async confirm(action) {
      // 	payment_detail_id:data.id,
      //   cs_bank_id:data.cs_bank_id,
      //   total_invoice:Number(data.total_invoice),
      //   finance_amount:0,
      //   note:data.cs_note,
      //   payment_status:0,
      //   cs_attachment_url:data.cs_attachment_url
      let formData = new FormData();
      await formData.append("payment_detail_id", this.form_data.payment_detail_id);
      await formData.append("cs_bank_id", this.selectedBank.bank_account_id);
      await formData.append(
        "finance_amount",
        action == "rejected" ? 0 : this.form_data.finance_amount
      );
      await formData.append("note", this.form_data.note);
      await formData.append("payment_status", action);
      await this.$emit("action", formData);
    },
    async openUpload() {
      const input = await document.getElementById("inputImage");
      input.click();
    },
    handleFileUpload(event) {
      this.formData.append("image", event);

      if (!event) return;

      this.createImage(event);
    },
    createImage(file) {
      var reader = new FileReader();

      reader.onload = (e) => {
        this.image = e.target.result;
      };
      reader.readAsDataURL(file);
    },
  },
};
</script>
